var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center"},[_c('div',{staticClass:"tw-w-6 tw-h-6 tw-rounded-full tw-bg-white tw-ring-24 tw-ring-white/20"}),_vm._v(" "),_c('div',{staticClass:"tw-grow tw-h-0 tw-border-t tw-border tw-border-white tw-border-dashed"}),_vm._v(" "),_c('div',{staticClass:"tw-w-4 tw-h-4 tw-rounded-full tw-bg-white tw-ring-8 tw-ring-white/20"})])
}]

export { render, staticRenderFns }